(function (upp) {
    'use strict';
    
    upp.directive('aboutCurrentPageTpl', [
        function () {
            return {
                restrict : 'E',
                replace : true,
                template : '<current-page-tpl data-page-title="ABOUT.KEY" data-page-key="about"></current-page-tpl>'
            };
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/about/directives/about-current_section-directive.js